import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "contact-page style-5" }
const _hoisted_2 = { class: "community section-padding style-5" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "section-head text-center style-4 mb-40" }
const _hoisted_5 = { class: "title_small" }
const _hoisted_6 = { class: "mb-20" }
const _hoisted_7 = { class: "contact section-padding pt-0 style-6" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col-lg-8" }
const _hoisted_12 = { class: "form" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  key: 0,
  class: "text-center text-danger fs-12px mb-30"
}
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "form-group mb-20" }
const _hoisted_17 = { class: "col-lg-6" }
const _hoisted_18 = { class: "form-group mb-20" }
const _hoisted_19 = { class: "col-lg-12" }
const _hoisted_20 = { class: "form-group mb-20" }
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "col-lg-12 text-center mt-20" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/img/icons/contact_a.png",
  alt: "",
  class: "contact_a"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/img/icons/contact_message.png",
  alt: "",
  class: "contact_message"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$t("contact.contactUs")), 1),
          _createElementVNode("h2", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t("contact.getIn")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("contact.touch")), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("contact.touch1")), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.isNotValid())
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.isNotValid()), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.name) = $event)),
                        type: "text",
                        name: "name",
                        class: "form-control",
                        placeholder: "Name"
                      }, null, 512), [
                        [_vModelText, _ctx.data.name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.email) = $event)),
                        type: "email",
                        name: "email",
                        class: "form-control",
                        placeholder: "Email Address *"
                      }, null, 512), [
                        [_vModelText, _ctx.data.email]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.title) = $event)),
                        type: "text",
                        name: "title",
                        class: "form-control",
                        placeholder: "Title  "
                      }, null, 512), [
                        [_vModelText, _ctx.data.title]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.content) = $event)),
                        rows: "10",
                        class: "form-control",
                        placeholder: "How can we help you?",
                        spellcheck: "false",
                        "data-ms-editor": "true"
                      }, null, 512), [
                        [_vModelText, _ctx.data.content]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("input", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.send())),
                      type: "button",
                      value: "Send Your Request",
                      class: "btn rounded-pill bg-blue4 fw-bold text-white text-light fs-12px"
                    })
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_24,
          _hoisted_25
        ])
      ])
    ])
  ]))
}